module.exports = {
  // REAL_ESTATE
  PLANET: 'planet',
  STATION: 'station',
  SECTOR: 'sector',

  // VEHICLE
  SHIP: 'ship',

  // RELATIONSHIP
  TRADE_AGREEMENT: 'trade agreement',

  // CORRIDOR
  PRIMARY_CORRIDOR: 'primary corridor',
  SECONDARY_CORRIDOR: 'secondary corridor',

  // RESOURCE
  ASTEROID_FIELD: 'asteroid field',
  GAS_GIANT: 'gas giant',

  // DISTINCTIONS
  PRESIDENT: 'president of the galaxy',
  COUNCIL_OF_FOUR: 'high council',
  EARLY_ADOPTER: 'founder',
  DIPLOMAT: 'diplomat',
};
